import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AboutmeComponent } from './components/aboutme/aboutme.component';
import { BlogComponent } from './components/blog/blog.component';
import { CvComponent } from './components/cv/cv.component';
import { ProfileComponent } from './components/profile/profile.component';
import { ProjectsComponent } from './components/projects/projects.component';
import {ProjectDetailsComponent} from './components/projects/project-details/project-details.component'
import { PublicationsComponent } from './components/publications/publications.component';
import { NewsComponent } from './components/news/news.component';
import { TeachingComponent } from './components/teaching/teaching.component';
import { EconResearchComponent } from './components/econ-research/econ-research.component';


const routes: Routes = [
  {path:'', redirectTo: 'aboutme', pathMatch: 'full'},
  {path:'aboutme', component:AboutmeComponent},
  {path:'cv', component:CvComponent},
  {path:'project', component:ProjectsComponent},
  {path:'publications', component:PublicationsComponent},
  {path:'blog', component:BlogComponent},
  {path:'profile',component:ProfileComponent},
  {path:'project-details', component:ProjectDetailsComponent},
  {'path':'news', component:NewsComponent},
  {'path':'teaching', component: TeachingComponent},
  {'path':'research', component: EconResearchComponent}
];

@NgModule({
  imports: [RouterModule.forRoot(routes,{scrollPositionRestoration: 'enabled'})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
